export enum UserRole {
  GroupPractice = 'GROUP_PRACTICE',
  Coach = 'COACH',
  Member = 'MEMBER',
  None = '',
}

export interface User {
  avatar?: string;
  email: string;
  newEmailAddressNotConfirmed?: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  uuid: string;
  id: number;
  birthDate?: string;
  languagePreferences: string[];
  country: string;
  zipCode?: string;
  city?: string;
  state?: string;
  introduction?: string;
  specialization?: string;
  credentials?: string;
  providerType?: string;
  localTimezone: string;
}
